import { toTitleCase } from 'src/utilities/string-utils';

export function transformBrandModelToUI(value: string): string {
  return toTitleCase(value.toLowerCase());
}
